module.exports = __webpack_public_path__ + "static/media/SanFrancisco.9a7280c4.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SanFrancisco.otf
// module id = 705
// module chunks = 4